import { useState } from 'react';
import RoundedImage from '../../components/RoundedImage';
import { formatMoneyKr } from '../../utils';
import { trackEvent } from '../../support-and-tracking/analytics-actions';
import VisibleIf from '../../components/VisibleIf';
import ButtonText from '../../components/button/button-text/ButtonText';
import { useProject } from '../project-hooks/useProject';
import styles from './matching-gift.module.less';
import { Link } from 'react-router';
import Image from '../../components/image/Image';

const MatchingGift = () => {
    const project = useProject();
    const [showExplanation, setShowExplanation] = useState(false);

    const { logo, orgName, maxAmount, matching, profile, paidAmount } = project.matchingGift;

    const toggleExplanation = () => {
        if (!showExplanation) {
            trackEvent('project', 'matching-tip', { 'project-id': project.id });
        }
        setShowExplanation(!showExplanation);
    };

    const matchingText = profile?.bannerText ? (
        <span className={styles.heading}>
            {profile?.bannerText}{' '}
            {profile?.customLink && (
                <Link className={styles.bannerLink} to={profile.customLink}>
                    Les&nbsp;mer
                </Link>
            )}
        </span>
    ) : (
        <span className={styles.heading}>
            {orgName} dobler beløpet <span className={styles.maxAmount}>inntil {formatMoneyKr(maxAmount)}</span>
        </span>
    );

    const notMatchingText = profile?.bannerText ? (
        <span className={styles.heading}>{profile?.bannerText}</span>
    ) : (
        <span className={styles.heading}>
            {orgName} har støttet innsamlingen med {formatMoneyKr(paidAmount)}
        </span>
    );
    // TODO: Replace RoundedImage with Avatar component
    return (
        <div className={styles.container}>
            <div className={styles.wrapper}>
                <div className={[styles.description, profile?.logo ? styles.descriptionWithLargeLogo : ''].join(' ')}>
                    {profile?.logo ? (
                        <Image className={styles.largeLogo} src={profile.logo} />
                    ) : (
                        logo && <RoundedImage src={logo} size={`40px`} className={styles.roundedImage} loading="lazy" />
                    )}
                    {matching ? matchingText : notMatchingText}
                    {matching && !profile?.customLink && (
                        <ButtonText tightFocus onClick={toggleExplanation} className={styles.showExplanation}>
                            Hva betyr dette?
                        </ButtonText>
                    )}
                    {matching && (
                        <VisibleIf isVisible={showExplanation}>
                            <div className={styles.explanation}>
                                For hver krone du gir, vil {orgName} doble giverbeløpet til denne spleisen – inntil{' '}
                                {formatMoneyKr(maxAmount)}.
                            </div>
                        </VisibleIf>
                    )}
                </div>
            </div>
        </div>
    );
};

export default MatchingGift;
